var map = {
	"./AashiqueAhmedIqbal.png": 600,
	"./BusinessintheTimeofContagion.jpeg": 601,
	"./KarunaWielenga.png": 602,
	"./LakshmiSubramanian.png": 603,
	"./LouizaRodrigues.png": 604,
	"./MadMenofBombay.png": 605,
	"./MilanBalaban.png": 606,
	"./PowerPrivilegePosture.jpeg": 607,
	"./SaritaSundar.png": 608,
	"./Speaker1.png": 609,
	"./SusiePak.png": 610,
	"./TheGlobalBlueJeansTransformation.jpg": 611,
	"./TimberTradeTrajectory.jpeg": 612,
	"./TraceyPanek.png": 613,
	"./TypewriterTipTip.png": 614,
	"./WilliamMazzarella.png": 615,
	"./details-banner/BusinessInTheTimeOfContagion.png": 616,
	"./details-banner/MadMenOfBombay.png": 617,
	"./details-banner/PowerPrivilegeposture.png": 618,
	"./details-banner/TheGlobalBlueJeans.png": 619,
	"./details-banner/TimberTradeTrajectory.png": 620,
	"./details-banner/TypewriterTipTip.png": 621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;